'use strict';

import HomeTracker from '../MetricsTracker/home/metrics';
import FooterTracker from '../MetricsTracker/footer/metrics';
import { bankImageSizes } from '../utils/constants/bankImageSizes'
import { getDepositBanks, getDepositAccountName, getDepositContactEmail } from '../utils/pricetravel/shared/bankUtils';
import { SearchHistory } from '../utils/pricetravel/shared/searchHistory';
import { HeroCarousel } from '../utils/HeroCarousel';
import LZString from 'lz-string';
import MealPlanNormalizer from '../utils/pricetravel/shared/MealPlanNormalizer';
window.app.controller('controller', controller);

controller.$inject = ["$scope", "$http", "$filter"];

function controller($scope, $http, $filter) {
    let vm = this;
    let __modal = "";
    let ln = window.__pt.ln || {};
    let setting = window.__pt.settings;
    let culture = window.__pt.culture;
    let tracker = new HomeTracker();
    let trackerFooter = new FooterTracker();
    let _user = window.__pt.user || null;
    let _isLogin = !!_user;
    let userLocation = window.__pt.userLocation;
    let settings = window.__pt.settings;
    let fn = window.__pt.fn;
    let isMobile = fn.mobileAndTabletCheck();
    let paramsSkillBase = {
        adultQuantity: 0,
        kidQuantity: 0,
        hotelId: 0,
        stepId: 2
    };
    let config = window.__pt.settings.site;
    vm.mealplans = MealPlanNormalizer.normalizeAll(ln.mealplans, config.siteName);
    let _successSkillBase = "200 - OK";
    vm.collectionHotel = window.__pt.collectionHotel;
    vm.collectionPromotion = window.__pt.collectionPromotion;
    vm.collectionVacation = window.__pt.collectionVacation;
    vm.culture = window.__pt.cultureData;
    vm.appNameSetting = setting.appName;
    vm.history = [];
    vm.viewed = [0, 1, 2];
    vm.isLogin = false;
    vm.responsePayment = {
        fixedPayments: [],
        monthInterestFree: [],
        loading: true
    };
    vm.ln = ln;
    vm.topPaymentBanks = [];

    vm.bannerTabs = {
        hotel: 'hotel',
        flight: 'flight',
        package: 'package',
        disney: 'disney'
    };

    vm.collapseHome = {
        hotel: false,
        fligth: false,
        package: false,
        home: false,
        homeabout: false

    }
    vm.currentTab = vm.bannerTabs.hotel;
    vm.onLoadPayment = (modal, btnTitle, btnText) => {
        __modal = modal;
        vm.showModal(__modal, btnTitle, btnText);
        onSearchPaymentMethod();
    }

    vm.showModal = (modal, btnTitle, btnText) => {
        $(`#${modal}`).modal("show");

        if (modal == "modal-payform" || modal == "modal-contact") {
            tracker.selectContent(btnTitle, btnText);
        }
    }

    vm.onClosed = (modal) => {
        $(`#${modal}`).modal("hide");
    }


    vm.showService = (services) => {
        const path = vm.currentTab;
        return services.indexOf(path) != -1;
    }

    vm.handleTab = (selectedTab, url) => {

        if (selectedTab === vm.bannerTabs.disney) {
            window.open(url, "_blank");
        } else {
            vm.currentTab = selectedTab;
            onChangePath();
        }
    }

    vm.sendContentFooter = (title) => {
        trackerFooter.clickLink(`footer :: ${title}`);
    }

    vm.onScreenCards = (item) => {
        if (vm.viewed.includes(item)) return;

        switch (item) {
            case 0:
                tracker.userViewPromotions(vm.collectionPromotion);
                break;
            case 1:
                tracker.userViewPromotions(vm.collectionHotel);
                break;
            case 2:
                tracker.userViewPromotions(vm.collectionVacation);
                break;

        }

        vm.viewed.push(item);
    };
    vm.selectRecap = () => {
        tracker.selectRecap();
    }
    vm.clickToRecap = () => {
        let recap = window.__pt.recap;
        if (recap != null && recap.success) {
            const lrecap = LZString.compressToEncodedURIComponent(
                JSON.stringify(recap)
            );
            vm.recapPath = `${setting.site.recapPath}?culture=${settings.site.siteName == 'pricetravel' ? 'mx' : 'co'}&traveler=${lrecap}`;
        }
    }
    vm.selectPromotion = (index, listName) => {
        tracker.userSelectPromotion(vm[listName], vm[listName].cards[index]);
    }

    function onSearchPaymentMethod() {
        if (vm.responsePayment.fixedPayments.length || vm.responsePayment.monthInterestFree.length) { return; }
        let params = {
            channel: setting.site.channel,
            language: vm.culture.internalCultureCode,
            currency: vm.culture.currency,
            isdeposit: true
        }
        $http.get(setting.site.endPoints.paymentMethodUrl, { params: params }).then(onSuccessPaymentMethods, onError)

    }

    function onSuccessPaymentMethods(response) {
        const data = response.data || [];
        const monthInterestFree = data.monthInterestFree ? data.monthInterestFree.options : [];
        const groupedPayments = monthInterestFree.reduce((groups, item) => {
            const maxMonths = Math.max(...item.paymentPlans);
            if (!groups[maxMonths]) {
                groups[maxMonths] = [];
            }
            groups[maxMonths].push(item);
            return groups;
        }, {});
        const sortedEntries = Object.entries(groupedPayments).sort(([keyA], [keyB]) => Number(keyB) - Number(keyA));

        const depositBanks = getDepositBanks(data);
        const depositAccountName = getDepositAccountName(data);
        const depositContactEmail = getDepositContactEmail(data);

        const paymentMethods = {
            fixedPayments: data.fixedPayments
                .map(fixedPayments => fixedPayments.options)
                .reduce((prev, curr) => prev.concat(curr), []),
            monthInterestFree: sortedEntries,
            quotasPayments: data.quotasPayments ? data.quotasPayments.options : [],
            otherPayments: data.otherPayments ? data.otherPayments.options : [],
            depositBanks: depositBanks,
            depositAccountName: depositAccountName,
            depositContactEmail: depositContactEmail,
            loading: false,
            maxmsi: data.monthInterestFree ? data.monthInterestFree.title : ""
        };
        vm.responsePayment = paymentMethods;
        vm.topPaymentBanks = getTopPaymentBanks(monthInterestFree).map(bank => {
            const iconKey = bank.icon?.toLowerCase() || normalizeIcon(bank.name);
            const size = bankImageSizes[iconKey] || { width: 78, height: 26 };
            return {
                ...bank,
                icon: iconKey,
                width: size.width,
                height: size.height
            };
        });
    }
    //Get skillBase
    function getSkillBase() {
        paramsSkillBase.site = config.domain;
        paramsSkillBase.device = isMobile ? "mobile" : "desktop"
        paramsSkillBase.product = "hotel";
        paramsSkillBase.user = __pt.user ? "user" : "anonymous";
        paramsSkillBase.country = __pt.culture.country;
        paramsSkillBase.login = _isLogin;


        $http.get(config.endPoints.skillBaseUrl, { params: paramsSkillBase }).then(onSuccessSkillBase);
    }
    //skillBase handler
    function onSuccessSkillBase(data) {
        let response = data.data;
        if (response.message == _successSkillBase) {
            let skillBase = response.result;
            vm.phoneBase = skillBase.did;
            $('.skillbase_p')
                .closest('a')
                .attr('href', `tel:${vm.phoneBase}`);
            $('.skillbase_p').text($filter('tel')(vm.phoneBase));
        }
    }

    function normalizeIcon(name) {
        return name.toLowerCase().replace(/\s+/g, '');
    }

    function getTopPaymentBanks(banks) {
        return [...banks]
            .filter(item => item.paymentPlans && item.paymentPlans.length > 0)
            .sort((a, b) => b.paymentPlans.length - a.paymentPlans.length)
            .slice(0, 7);
    }

    function onError(response) {
        console.log(response)
    }

    /**** Private ****/


    function getService() {
        let path = location.pathname.toLowerCase();
        let page = '';
        path = path.replace(`/${culture.cultureCode}`, "");
        const Airlines = "aeromexico,aircanada,airfrance,avianca,boletosaereos,clicair,continental,copa,iberia,jetblue,jetsmart,latam,satena,united,vivaaerobus,volaris,wingo";
        const airlinesList = Airlines.split(',');
        const getSecondSegment = (path) => {
            const segments = path.split('/').filter(s => s.trim() !== "");
            return segments.length > 0 ? `/${segments[0]}` : "/";
        };
        const secondSegmentPath = getSecondSegment(path);
        switch (secondSegmentPath) {
            case '/':
                page = config.siteName === "tiquetesbaratos" ? vm.bannerTabs.flight : vm.bannerTabs.hotel;
                break;
            case '/hoteles':
            case '/hotels':
                page = vm.bannerTabs.hotel;
                break;
            case '/alojamientos':
            case '/stays':
                page = vm.bannerTabs.hotel;
                break;
            case '/vuelos':
            case '/flights':
                page = vm.bannerTabs.flight;
                break;
            case '/paquetes':
            case '/packages':
                page = vm.bannerTabs.package;
                break;
            case '/tiquetes':
                page = vm.bannerTabs.flight;
                break;
            default:
                const segments = path.split('/').filter(s => s.trim() !== "");
                if (segments.length > 0) {
                    const lastSegment = segments[segments.length - 1];
                    const baseSegment = lastSegment.split('-')[0];
                    if (airlinesList.includes(baseSegment)) {
                        page = vm.bannerTabs.flight;
                    } else {
                        page = config.siteName === "tiquetesbaratos" ? vm.bannerTabs.flight : vm.bannerTabs.hotel;
                    }
                } else {
                    page = config.siteName === "tiquetesbaratos" ? vm.bannerTabs.flight : vm.bannerTabs.hotel;
                }
                break;
        }
        return page;
    }

    function getPathCurrent(tab) {
        let page = '';

        switch (tab) {
            case vm.bannerTabs.hotel:
                page = '/';
                break;

            case vm.bannerTabs.hotel:
                page = '/hoteles';
                break;

            case vm.bannerTabs.hotel:
                page = '/hotels';
                break;

            case vm.bannerTabs.fligth:
                page = '/vuelos';
                break;

            case vm.bannerTabs.fligth:
                page = '/flights';
                break;

            case vm.bannerTabs.package:
                page = '/paquetes';
                break;

            case vm.bannerTabs.package:
                page = '/packages';
                break;
        }

        return page;
    }

    new HeroCarousel('.hero');

    function onChangePath() {
        let path = getPathCurrent(vm.currentTab);
    }

    function init() {

        if (_user && _user.firebaseId) {
            vm.isLogin = true;
            vm.clickToRecap();
        } else {
            vm.isLogin = false;
        }
        vm.currentTab = getService();
        onChangePath();

        if (!window.__pt.settings.rb) {
            initHistorySearch();
            if (_isLogin) {
                if (settings.site.siteName == "pricetravel" && userLocation.country == "MX") {
                    getSkillBase();
                }
            }
        }
    }

    function initHistorySearch() {
        var path = location.pathname.toLowerCase();;
        var type = SearchHistory.getLandingPagePath(path);
        vm.history = SearchHistory.getRecentSearches(type);
    }

    $scope.$evalAsync(() => {
        document.querySelectorAll('.carousele__container').forEach(container => {
            initCarousel(container);
        });
    });

    init();

}
